import { render, staticRenderFns } from "./RequisitionFormModal.vue?vue&type=template&id=8901adc0&scoped=true&"
import script from "./RequisitionFormModal.vue?vue&type=script&lang=js&"
export * from "./RequisitionFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8901adc0",
  null
  
)

export default component.exports